// @flow
import * as React from 'react';

import useEventListener from './useEventListener';
import useLatest from './useLatest';

const useVisibilityChange = (
    callback?: (isVisible: boolean) => void
): boolean => {
    const [isVisible, setIsVisible] = React.useState(true);
    const callbackRef = useLatest(callback);
    const getIsVisible = () => {
        return document.visibilityState === 'visible';
    };

    const onVisibilityChange = () => {
        setIsVisible(getIsVisible);
        callbackRef.current?.(getIsVisible());
    };

    React.useEffect(() => {
        onVisibilityChange();
    }, []);

    useEventListener(document, 'visibilitychange', () => {
        onVisibilityChange();
    });

    return isVisible;
};

export default useVisibilityChange;
